<p class="intro" [innerHTML]="'parameters/alcmeon-ai/agents/intro' | translate"></p>

<app-search-bar
  [primaryButtonAction]="newAgent"
  [primaryButtonKey]="'parameters/alcmeon-ai/agents/button-new'"
  [searchKey]="'parameters/alcmeon-ai/agents/search-placeholder'"></app-search-bar>

<app-table [config]="config" [filters]="filters"></app-table>

<ng-template #knowledgeDocumentsCounter let-counter="counter">
  <ng-container *ngIf="!knowledgeDocsCountersLoading; else loading">
    <ng-container *ngIf="counter; else noDoc">
      {{ counter }}
    </ng-container>
    <ng-template #noDoc>
      <span translate="parameters/alcmeon-ai/agents/table/no-doc" class="error"></span>
    </ng-template>
  </ng-container>
  <ng-template #loading>
    <mat-progress-bar mode="indeterminate" class="counter-progress"></mat-progress-bar>
  </ng-template>
</ng-template>
